import * as React from "react";
const SvgFiRrBike = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19.783 12.079a74 74 0 0 0-.555-1.873A23 23 0 0 1 18 5a1 1 0 0 1 2 0 1 1 0 0 0 2 0 3 3 0 1 0-6 0c.024.764.131 1.522.319 2.263L11.519 11 5.97 7H9a1 1 0 1 0 0-2H5.97A1.969 1.969 0 0 0 4.81 8.559l5.07 3.712-1.437 1.119a4.954 4.954 0 1 0 1.15 1.638l7.289-5.669c.14.476.727 2.384.856 2.823a4.994 4.994 0 1 0 2.046-.1zM5 20a3 3 0 1 1 0-6 3 3 0 0 1 0 6m14 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
    />
  </svg>
);
export default SvgFiRrBike;
